import Fuse from 'fuse.js';
import movies from '../JSON/movies.json';
import { renderMovies } from '../../../modules/renderMovies.js';
import { createPagination } from '../../../modules/pagination.js';
import { sortMovies } from '../../../modules/sort.js';



const path = './JSON/movies.json';
let data = [];
const movieContainer = document.querySelector(".movie-container");
const pagination = document.querySelector('#pagination');
const selectComp = document.querySelector('#select');
const reverseBtn = document.querySelector('#reverse');
const count = document.querySelector('.movie-count');
const searchInput = document.querySelector('#search');

let currentPage = 1;
const maxDisplayLimit = 25;

data = movies;
count.innerText = movies.length;

movieContainer.appendChild(renderMovies(data.sort((a, b) => {
    let fa = a.title.toLowerCase(),
    fb = b.title.toLowerCase();
    if (fa < fb) {
    return -1;
    }
    if (fa > fb) {
    return 1;
    }
    return 0;
}), 1, "Attori", "Durata", "Regia"));

pagination.appendChild(createPagination(data, currentPage, "Inizio", "Fine", "Avanti", "Indietro"));

// let searchIndex = createSearchIndex(data);
// console.log(searchIndex);

const options = {
    // isCaseSensitive: false,
    // includeScore: true,
    shouldSort: true,
    // includeMatches: false,
    // findAllMatches: false,
    // minMatchCharLength: 5,
    // maxPatternLength: 5,
    // location: 0,
    threshold: 0.2,
    // distance: 50,
    // useExtendedSearch: false,
    ignoreLocation: true,
    // ignoreFieldNorm: false,
    // fieldNormWeight: 1,
    // tokenize: true,
    keys: [
        "title",
        {
            name: 'director',
            weight: 2
        },
        {
            name: 'actors',
            weight: 2
        },
        "subtitle",
        "bodycopy"
    ]
};

const fuse = new Fuse(data, options);

// Modul? Für Suchfilter

let searchValue = "";


const searchData = () => {

    searchValue = searchInput.value;
    let results = fuse.search(searchValue);

    if (results.length === 0) {
        const errorMessage = document.createElement('li');
        errorMessage.textContent = "Attualmente non ci sono spettacoli in questa rubrica."
        movieContainer.replaceChildren(errorMessage);
    } else {
        movieContainer.replaceChildren(renderMovies(results.map(ele => ele.item), 1, "Attori", "Durata", "Regia"));
        pagination.replaceChildren(createPagination(results.map(ele => ele.item), currentPage, "Inizio", "Fine", "Avanti", "Indietro"));
    }
    data = results.map(ele => ele.item);
}

function handleChange(e) {
    searchValue = e.target.value;
    if (searchValue.length === 0) {
        data = movies;
        // movieContainer.replaceChildren(renderMovies(data));
        // pagination.replaceChildren(createPagination(data, currentPage));
    }
}
function searchOnKeyPress(e) {
    if (e.key === "Enter") {
        e.preventDefault();
        searchData();
    }
}

searchInput.addEventListener("keypress", searchOnKeyPress);
searchInput.addEventListener("change", handleChange);

const searchButton = document.querySelector('#searchBtn');
searchButton.addEventListener('click', searchData);

const cancelSearch = document.querySelector('#cancelSearch');

cancelSearch.addEventListener('click', () => {
    searchInput.value = "";
    data = movies;
    movieContainer.replaceChildren(renderMovies(data, 1, "Attori", "Durata", "Regia"));
    pagination.replaceChildren(createPagination(data, currentPage, "Inizio", "Fine", "Avanti", "Indietro"));
})

function sort() {
    const sortParam = selectComp.value;
    sortMovies(data, sortParam);
}


selectComp.addEventListener('change', sort);

function reverse() {
    data.reverse();
    movieContainer.replaceChildren(renderMovies(data, 1, "Attori", "Durata", "Regia"));
    pagination.replaceChildren(createPagination(data, 1, "Inizio", "Fine", "Avanti", "Indietro"));
}

reverseBtn.addEventListener('click', reverse);